import type { TSelectedTab } from 'stores/detailsPanelStore/detailsPanelStore'

export const getPanelStateAfterTabClick = ({
  isPanelOpen,
  selectedTab,
  clickedTab,
}: {
  isPanelOpen: boolean
  selectedTab: TSelectedTab
  clickedTab: TSelectedTab
}) => {
  if (clickedTab !== selectedTab) return { isPanelOpen: true, selectedTab: clickedTab }

  if (isPanelOpen) return { isPanelOpen: false, draggedPanelSize: null }

  return { isPanelOpen: true }
}
